import { BlobProvider } from "@react-pdf/renderer";
import * as React from "react";
import { Provider } from "react-redux";
import { store } from "../../index";

type DocProps = {
    loading: boolean;
    url: string;
    name: string;
    setDownloaded: () => void;
};

/**
 * Control for downloading a pdf from html
 */
class Document extends React.Component<DocProps> {
    public componentDidUpdate(prevProps: DocProps) {
        if (!this.props.loading && prevProps.loading) {
            const link = document.createElement("a");
            link.download = this.props.name;
            link.href = this.props.url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.props.setDownloaded();
        }
    }
    public render() {
        return <div />;
    }
}

type Props = {
    loadPdf: boolean
    setLoadPdf: (value: boolean) => void
    name: string
    children: React.ReactNode
};

export default (props => <>
    {props.loadPdf && (
        // This renders the PDF blob provider which kicks off the download once the PDF is ready.
        // We conditionally render like this for performance.
        <BlobProvider
            document={
                <Provider store={store}>
                    {props.children}
                </Provider>
            }
        >
            {blobProps => (
                <Document
                    loading={blobProps.loading}
                    url={blobProps.url!}
                    name={props.name}
                    // This hides the blob provider ready for another download.
                    setDownloaded={() => props.setLoadPdf(false)}
                />
            )}
        </BlobProvider>
    )}
</>) as React.FC<Props>;
